export default "__VITE_ASSET__f8de93c6__"